import { getWhatsappLinkFromPhone } from "./getWhatsappLinkFromPhone";

export function getMenu(component) {
  const menu = [];

  if (!component.about && !component.howBuy) return menu;

  const config = component.config;

  if (component.about)
    menu.push({
      text: "Quem Somos",
      bind: {
        to: "/quem-somos",
      },
    });

  menu.push({
    text: "Fale Conosco",
    bind: {
      href: getWhatsappLinkFromPhone(config.whatsapp),
      target: "_blank",
    },
  });

  if (component.howBuy)
    menu.push({
      text: "Como Comprar",
      bind: {
        to: "/como-comprar",
      },
    });

  return menu;
}
